<template>
  <div 
  :class="{ outofstock : item.status == 'sold_out' }"
  @click="$router.push({ path: `/store/${item.slug}` })"
  @mouseenter="hover = true;"
  @mouseleave="hover = false;">
    <img v-show="!hover || !item.cover2" :src="$store.state.$fileBaseURL + item.id + '/' + item.cover"/>
    <img v-show="hover && item.cover2" :src="$store.state.$fileBaseURL + item.id + '/' + item.cover2"/>

    <p>{{ item.title }}</p>
    <p v-if="item.status == 'available'">{{ item.price_round > 0 ? '&#8364;' + item.price_round : '' }}<span v-if="item.price_decimal">, {{ item.price_decimal }}</span>
    </p>
    <p v-else>Sold Out</p>
  </div>
</template>

<script>
export default {
  name: 'ShopTile',
    data() {
    return {
      hover: false
    }
  },
  props: ['item']
}
</script>

<style scoped>

</style>